<template>
  <table class="player-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">№</th>
        <th scope="col">Player</th>
        <th scope="col">Score</th>
      </tr>
    </thead>
    <tr
      v-for="(record, index) in rating"
      :key="record.entityId"
    >
      <td class="num">
        {{index + 1 | getFormattedNumber}}
      </td>
      <td>
        <player-link :playerId="record.entityId" lable="player" />
      </td>
      <td class="num">
        {{record.score | getFormattedNumber}}
      </td>
    </tr>
    <tr v-if="isScoreSumVisible">
      <td colspan="3" class="text-right pt-4">
        Score sum: {{ scoreSum | getFormattedNumber }}
      </td>
    </tr>
  </table>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'ContestTeaPlayerRating',

  components: {
    PlayerLink,
  },

  props: {
    rating: {
      type: Array,
      required: true,
    },
  },

  computed: {
    /** @returns {boolean} */
    isScoreSumVisible() {
      return this.rating.length > 1;
    },

    /** @returns {number} */
    scoreSum() {
      let sum = 0;

      for(const record of this.rating) {
        sum += record.score;
      }

      return sum;
    },
  },
};
</script>

<style scoped>
.num {
  text-align: right;
}

.player-table {
  width: 1px;
}
</style>
